import { useEditPipelineWizard } from './hooks/useEditPipelineWizard';
import { useEditPipelineContext } from './hooks/useEditPipelineContext';
import { EditPipelineWizardHeaderLeft } from './components/EditPipelineWizardHeaderLeft/EditPipelineWizardHeaderLeft';
import { Wizard } from '../../wizard/Wizard/Wizard';
import { useConfirm } from '../../modal/ConfirmModal/useConfirm';
import { PipelineAPI } from '../api/PipelineAPI';
import { DiscardChangesConfirmModalBody } from '../../shared/components/DiscardChangesConfirmModalBody/DiscardChangesConfirmModalBody';

export function EditPipelineWizard() {
  const { pipeline } = useEditPipelineContext();
  const { confirm } = useConfirm();

  const {
    wizardState,
    currentStep,
    stepGroups,
    stepTreeSnapshot,
    onCancelClick,
    onBackClick,
    selectStepGroup,
    currentStepFooterProps
  } = useEditPipelineWizard({ integration: pipeline! });

  const cancel = () => {
    confirm({
      title: 'Discard Changes',
      negativeButtonText: "Don't Discard",
      positiveButtonText: 'Discard',
      BodyComponent: DiscardChangesConfirmModalBody
    })
      .then(confirmed => {
        if (confirmed) {
          return PipelineAPI.cancelPipelineEditSave(pipeline!.id);
        }

        return undefined;
      })
      .then(res => {
        if (res) {
          onCancelClick();
        }
      })
      .catch(() => {});
  };

  return (
    <Wizard
      wizardState={wizardState}
      currentStep={currentStep}
      stepGroups={stepGroups}
      stepTreeSnapshot={stepTreeSnapshot}
      currentStepFooterProps={currentStepFooterProps}
      onBackClick={onBackClick}
      onCancelClick={cancel}
      selectStepGroup={selectStepGroup}
      WizardHeaderLeftComponent={EditPipelineWizardHeaderLeft}
      wizardHeaderLeftComponentProps={{ pipeline }}
      trackingProps={{
        wizard: 'PIPELINE_EDIT'
      }}
    />
  );
}
